<template>
  <div>
    <Multiselect
      v-model="value"
      :options="brands"
      :show-labels="false"
      :placeholder="placeholder"
      track-by="name"
      label="name"
      open-direction="bottom"
      :disabled="isDisabled"
    >
      <span slot="caret" class="icon-left">
        <Icon icon-name="car">
          <CarIcon></CarIcon>
        </Icon>
      </span>
      <span slot="caret" class="arrow">
        <Icon icon-name="modelsCaret" width="16" height="16" direction="up">
          <Arrow></Arrow>
        </Icon>
      </span>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Icon from '@/components/shared/Icons/Icon'
import Arrow from '@/components/shared/Icons/arrow.svg'
import CarIcon from '@/components/shared/Icons/car.svg'
export default {
  components: {
    Multiselect,
    Icon,
    CarIcon,
    Arrow,
  },
  props: {
    brands: { type: Array, default: () => [] },
    placeholder: { type: String },
    selectedBrand: { type: Object },
    selectBrand: { type: Function, default: () => {} },
    isLoading: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },
  computed: {
    value: {
      // VUE MULTISELECT DOESNT DISPLAY PLACEHOLDER
      // IF EMPTY VALUE IS !== []
      get() {
        return this.selectedBrand && this.selectedBrand.id
          ? this.selectedBrand
          : []
      },
      set(brand) {
        this.selectBrand(brand)
      },
    },
  },

  methods: {},
}
</script>
